module.exports = __webpack_public_path__ + "static/media/Fancy-diamond.d6b9caf5.jpg";